import { type Fn, isFunction } from '@damilaredev/utils'
import type { ResponseInterface, Session } from '~/types'
import { isAuthenticationError } from '~/utils/auth'

export const useProfileQuery = (options?: {
  onError?: Fn<void, Error>
  onSuccess?: Fn<void, Session>
}) => {
  const { logout, updateUser } = useAuthStore()

  return useQuery(
    [VQProfileKey],
    () =>
      useRequest().get<ResponseInterface<Session>>('session', {
        baseURL: useRuntimeConfig().public.baseUrl,
      }),
    {
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      onSuccess: (data) => {
        updateUser(data.data.data)
        nextTick(() => {
          if (isFunction(options?.onSuccess)) {
            options?.onSuccess!(data.data.data)
          }
        })
      },
      onError: (error: Error) => {
        if (isAuthenticationError(error)) {
          logout()
          if (options?.onError) options.onError(error)
        }
      },
    },
  )
}
